module.exports = __webpack_public_path__ + "media/images/patent/x_5-ed84b9af0edc6085e8730796d4aecabd.png";